import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ObsidianNoteDTO } from '../core/models/obsidian-note.model';
import { DatePipe, NgFor, NgIf } from '@angular/common';
import { WindowRefService } from '../core/services/windowRef.service';
import { LozengeComponent } from '../shared/lozenge/lozenge.component';

export interface SelectedNoteEvent {
  selectedNote: ObsidianNoteDTO;
}

@Component({
  selector: 'app-notes',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [NgFor, DatePipe, LozengeComponent, NgIf],
  templateUrl: './notes.component.html',
})
export class NotesComponent implements OnChanges {
  @Input() notes: ObsidianNoteDTO[] = [];
  @Input() selectedNote?: ObsidianNoteDTO;
  @Output() onSelectedNote = new EventEmitter<SelectedNoteEvent>();

  constructor(private windowRefService: WindowRefService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.notes.forEach(note => {
      if (note.expanded && note.id === this.selectedNote?.id) {
        note.content = this.selectedNote?.content ?? '';
        note.formattedContent = this.selectedNote?.formattedContent ?? '';
      }
    });
  }

  viewNote(note: any) {
    this.selectedNote = undefined;
    note.expanded = !note.expanded;
    if (note.expanded) {
      this.onSelectedNote.emit({ selectedNote: note });
      this.windowRefService.AP.resize('', 350);
    } else {
      this.windowRefService.AP.resize('', 250);
    }
  }
}
